import { Component } from '@angular/core';

// Blank placeholder route used by PolicyHeaderComponent.triggerSaveGuards() so the
// active tab's SaveGuard fires without routing to an unmatched URL (which renders the 404 page).
@Component({
  selector: 'app-save-transition',
  template: ''
})
export class SaveTransitionComponent { }
